import { FreestyleItem } from "types/data";
import { StatefulFreestyleItem } from "types/freestyle.types";

export default (data: FreestyleItem[]): StatefulFreestyleItem[]=> {
  return data.map(item => {
    const newData = {
      ...item,
      counter: item.counter ? 
        {
          ...item.counter,
          current: 0
        }
        :
        undefined,

    }    

    return newData
  })
}